"use client";

import styles from "./checkout-card.module.css";
import SalifyLink from "src/lib/components/link/salify-link";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import React, { ChangeEvent, useState } from "react";
import { SelectItem } from "./common";

export interface CheckoutCardAddressProps {
  label: string;
  provinceOptions: SelectItem[];
  selectedProvince?: string; // SelectItem.value
  districtOptions: SelectItem[];
  selectedDistrict?: string; // SelectItem.value
  wardOptions: SelectItem[];
  selectedWard?: string; // SelectItem.value
  address?: string;
  output?: (data: any) => void;
}

const CheckoutCardAddress = (props: CheckoutCardAddressProps) => {
  const {
    label,
    provinceOptions,
    selectedProvince,
    districtOptions,
    selectedDistrict,
    wardOptions,
    selectedWard,
    address,
    output,
  } = props;
  const [province, setProvince] = useState(selectedProvince);
  const [district, setDistrict] = useState(selectedDistrict);
  const [ward, setWard] = useState(selectedWard);
  const [adrs, setAdrs] = useState(address);

  const onChangeProvinceOption = (event: SelectChangeEvent) => {
    setProvince(event.target.value as string);
  };

  const onChangeDistrictOption = (event: SelectChangeEvent) => {
    setDistrict(event.target.value as string);
  };

  const onChangeWardOption = (event: SelectChangeEvent) => {
    setWard(event.target.value as string);
  };

  const onChangeAddress = (event: ChangeEvent<HTMLInputElement>) => {
    setAdrs(event.target.value);
  };

  return (
    <Card className={styles.cardBox}>
      <Box className={styles.boxTitle}>{label}</Box>
      <Grid container spacing={4} sx={{ display: "flex", flexDirection: "row" }}>
        <Grid item md={6} sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl sx={{ margin: "0 0 16px" }}>
            <TextField label="Full Name" size="small" />
          </FormControl>
          <FormControl size="small" sx={{ margin: "0 0 16px" }}>
            <TextField label="Phone Number" size="small" />
          </FormControl>
          <FormControl size="small" fullWidth sx={{ margin: "0 0 16px" }}>
            <TextField
              label="Số nhà, tên đường..."
              placeholder="Số nhà, tên đường..."
              size="small"
              onChange={onChangeAddress}
              value={adrs}
            />
          </FormControl>
          <FormControl size="small" fullWidth sx={{ margin: "0 0 16px" }}>
            <InputLabel>Quận/Huyện</InputLabel>
            <Select
              onChange={onChangeDistrictOption}
              value={district}
              label="Quận/Huyện"
              //placeholder="Chọn Quận/Huyện"
            >
              {districtOptions &&
                districtOptions.map((option, idx) => (
                  <MenuItem value={option.value} key={`districtOption${idx}`}>
                    {option.label}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={6} sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl size="small" fullWidth sx={{ margin: "0 0 16px" }}>
            <TextField label="Email Address" size="small" />
          </FormControl>
          <FormControl size="small" fullWidth sx={{ margin: "0 0 16px" }}>
            <TextField label="Ghi chú" placeholder="Ghi chú" size="small" />
          </FormControl>
          <FormControl size="small" fullWidth sx={{ margin: "0 0 16px" }}>
            <InputLabel>Phường/Xã</InputLabel>
            <Select
              onChange={onChangeWardOption}
              value={ward}
              label="Phường/Xã"
              //placeholder="Chọn Phường/Xã"
            >
              {wardOptions &&
                wardOptions.map((option, idx) => (
                  <MenuItem value={option.value} key={`wardOption${idx}`}>
                    {option.label}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControl size="small" fullWidth sx={{ margin: "0 0 16px" }}>
            <InputLabel>Thành phố/Tỉnh</InputLabel>
            <Select
              onChange={onChangeProvinceOption}
              value={province}
              label="Thành phố/Tỉnh"
              //placeholder="Chọn Thành phố/Tỉnh"
            >
              {provinceOptions &&
                provinceOptions.map((option, idx) => (
                  <MenuItem value={option.value} key={`provinceOption${idx}`}>
                    {option.label}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Card>
  );
};

CheckoutCardAddress.displayName = "CheckoutCardAddress";

export default CheckoutCardAddress;
